// @flow

import React, { type Node } from 'react';
import { type Country } from '@tectonics/prs/country';
import {
  getCountry,
  getSafeDueDate,
  usePendingIncomingPayment,
} from '@tectonics/prs/incoming-payment';
import { formatDueDate } from '@tectonics/prs/cash-mexico';
import { PaymentInfo } from './payment-info';

export function DisplayDueDate(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);
  if(incomingPayment.status !== 'PE')
    throw new Error(`Paynet: invalid payment status ${incomingPayment.status}, it should be PE`);

  return (
    <PaymentInfo label={getPaymentInfoLabelText(country)}>
      {formatDueDate(getSafeDueDate(incomingPayment))}
    </PaymentInfo>
  );
}

function getPaymentInfoLabelText(country: Country): string {
  switch (country) {
    case 'bo':
      return 'Vencimiento:';
    default:
      return 'Vencimento:';
  }
}
